import React, { useContext } from 'react';
import { UserContext } from '../contexts/UserContext';
import { RESTPost } from '../services/types';
import { PencilIcon } from '@heroicons/react/24/solid';
import maitreCorbackIcon from '../assets/icons/maitre_corback_icon.png';
import './AuthorButton.css';

interface AuthorButtonProps {
    post: RESTPost;
    onClick: () => void;
    isTrashed?: boolean;
    orthoCorrection?: string;
}

const AuthorButton: React.FC<AuthorButtonProps> = ({
    post,
    onClick,
    isTrashed = false,
    orthoCorrection = ''
}) => {
    const { currentUser } = useContext(UserContext);

    const isAuthor = currentUser && currentUser.id === post.author;
    if (!isAuthor || isTrashed) {
        return null;
    }

    const hasOrthoCorrection = orthoCorrection.trim() !== '';

    return (
        <button
            type="button"
            className={`AuthorButton ${hasOrthoCorrection ? 'ortho-correction' : ''}`}
            onClick={onClick}
            title={hasOrthoCorrection ? `Correction demandée: ${orthoCorrection}` : 'Gérer ma BD'}
        >
            {hasOrthoCorrection ? (
                <img src={maitreCorbackIcon} alt="Correction demandée" className="correction-icon" />
            ) : (
                <PencilIcon className="edit-icon" />
            )}
        </button>
    );
};

export default AuthorButton;
